
const Index = () => import(/* webpackChunkName: "product-report" */ "./index");
const ProductList = () => import(/* webpackChunkName: "product-report" */ "./ProductList");

export default [{
  path: 'product',
  name: 'product',
  component: Index,
  redirect: {
    name: 'product-list-report'
  },
  children: [{
    path: 'list',
    name: 'product-list-report',
    component: ProductList,
  }, ],

}, ]